import { ReactComponent as LogoMark } from 'assets/icons/main-logo.svg';

/*
 * The Clover Brokers mark, drawn inline rather than as a CSS background.
 * Inline it is rendered with the page like text, so its thin "brokers"
 * strokes stay sharp under fractional display scaling (125%, 175%), where a
 * background image is resampled and comes out soft.
 */
// The four-leaf diamond on its own sits in the first 24.7 units of the
// artwork, so the mark is the same file with a narrower window onto it.
const MARK_VIEWBOX = '0 0 24.7 24.311';

export default function Logo({
  className,
  variant = 'full',
}: {
  className?: string;
  variant?: 'full' | 'mark';
}) {
  return (
    <LogoMark
      className={className}
      aria-hidden="true"
      focusable="false"
      preserveAspectRatio="xMinYMid meet"
      shapeRendering="geometricPrecision"
      {...(variant === 'mark' && { viewBox: MARK_VIEWBOX })}
    />
  );
}
